var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNewLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "37f21bd3-2265-4075-807f-b9417b66d3c1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 171.33,
    height: 154,
    viewBox: "0 0 171.33 154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "4b79f687-7d68-4831-8bbc-2b32e7dade1d",
    cx: 85.73,
    cy: 79.46,
    r: 77.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#faee7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fbe571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fed659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce4d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "67e64720-a2b6-4f92-a732-f2c46f8f5851",
    cx: 85.73,
    cy: 100.49,
    r: 6.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3837e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ee7c77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e26964"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "6a34c2e1-e381-4e37-9236-fd35b075619c",
    cx: 48.54,
    cy: 84.44,
    r: 19.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a94b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#188db2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#14799d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0d5a7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073e5e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b42ba3bc-3b34-41ab-8755-ff8180d5d173",
    cx: 122.63,
    cy: 85,
    r: 19.06,
    xlinkHref: "#6a34c2e1-e381-4e37-9236-fd35b075619c"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconNewLevel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.79,118.63c-7.71,13-25.12,25.05-47.14,31A107.41,107.41,0,0,1,104.14,152q-1.59.15-3.24.27c-3.59.27-7.38.44-11.34.52-1.25.11-2.51.2-3.79.26h-.08c-1.28-.06-2.55-.15-3.79-.26-3.4-.06-6.66-.21-9.79-.41-1.63-.1-3.23-.23-4.79-.38a107.07,107.07,0,0,1-11.52-2.42c-22-5.9-39.42-17.92-47.14-31-3.49-5.91-5-12-4-17.9.11-.67.26-1.35.44-2A21,21,0,0,1,6.46,95a22.29,22.29,0,0,0,1.48-2.6,21.34,21.34,0,0,0,1.39-3.75,21,21,0,0,0,.72-6c0-.51,0-1-.08-1.54-.05-.9-.07-1.82-.09-2.74A102.47,102.47,0,0,1,13,50.26,72.76,72.76,0,0,1,41.26,17.64a78,78,0,0,1,26.13-10Q71,6.93,74.77,6.5c2.2-.24,4.44-.42,6.71-.52,1.4-.06,2.82-.09,4.25-.1,1,0,2.09,0,3.13.06q3.18.1,6.26.4,3.76.36,7.38,1a78.35,78.35,0,0,1,27.69,10.3,72.76,72.76,0,0,1,28.23,32.62,102.08,102.08,0,0,1,3.15,28.08c0,.92,0,1.84-.09,2.74,0,.51-.07,1-.08,1.54a21.37,21.37,0,0,0,2.11,9.75A23.84,23.84,0,0,0,165,95a21,21,0,0,1,1.39,3.74c.18.67.33,1.35.44,2C167.79,106.59,166.29,112.72,162.79,118.63Z",
    fill: "url(#4b79f687-7d68-4831-8bbc-2b32e7dade1d)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.79,118.63c-7.71,13-25.12,25.05-47.14,31A107.41,107.41,0,0,1,104.14,152q-6.83.63-14.58.79c-1.25.11-2.51.2-3.79.26h-.08c-1.28-.06-2.55-.15-3.79-.26q-7.77-.15-14.58-.79a107.07,107.07,0,0,1-11.52-2.42c-22-5.9-39.42-17.92-47.14-31-3.17-5.36-4.7-10.9-4.23-16.25,0,.34.06.68.11,1a29.86,29.86,0,0,0,4.12,11.43c7.72,13,25.13,25,47.14,30.94a107.14,107.14,0,0,0,11.52,2.43c4.54.42,9.4.69,14.58.78,1.24.12,2.51.2,3.79.26h.08c1.28-.06,2.54-.14,3.79-.26,5.17-.09,10-.36,14.58-.78a107.48,107.48,0,0,0,11.51-2.43c22-5.89,39.43-17.91,47.14-30.94a29.89,29.89,0,0,0,4.13-11.43c.05-.34.08-.68.11-1C167.5,107.73,166,113.27,162.79,118.63Z",
    fill: "#f1b02e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.12,42.87c.31,2.11-2.93,6.14-7.83,9.58-4.62,3.23-9.24,4.89-11.33,4.22a1.63,1.63,0,0,1-.87-.6c-1.28-1.82,2.12-6.4,7.58-10.23S42.6,40.4,43.88,42.22A1.42,1.42,0,0,1,44.12,42.87Z",
    fill: "#f1b02e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.33,42.87c-.3,2.11,2.93,6.14,7.83,9.58,4.62,3.23,9.24,4.89,11.33,4.22a1.63,1.63,0,0,0,.87-.6c1.28-1.82-2.12-6.4-7.58-10.23s-10.93-5.44-12.2-3.62A1.32,1.32,0,0,0,127.33,42.87Z",
    fill: "#f1b02e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.76,119.25c-.17,1.84-7.08,2.74-15.45,2s-15-2.82-14.86-4.67,7.08-2.74,15.45-2S31.92,117.4,31.76,119.25Z",
    fill: "#f1b02e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.43,129.34c.16,1.85-6.49,3.94-14.86,4.67s-15.28-.17-15.44-2,6.49-3.93,14.85-4.66S32.27,127.5,32.43,129.34Z",
    fill: "#f1b02e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.24,116.16c.14,1.57,6,2.34,13.13,1.71s12.77-2.39,12.63-4-6-2.34-13.13-1.72S144.11,114.59,144.24,116.16Z",
    fill: "#f1b02e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.24,124.17c-.13,1.57,5.52,3.35,12.63,4s13-.15,13.13-1.71-5.52-3.35-12.63-4S144.38,122.6,144.24,124.17Z",
    fill: "#f1b02e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.78,100.49c0,2.35-3.61,4.25-8,4.25s-8-1.9-8-4.25,3.6-4.25,8-4.25S93.78,98.14,93.78,100.49Z",
    fill: "url(#67e64720-a2b6-4f92-a732-f2c46f8f5851)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.65,98.7c0,.74-1,1.34-2.13,1.34s-2.12-.6-2.12-1.34.95-1.34,2.12-1.34S90.65,98,90.65,98.7Z",
    fill: "#facac2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.55,6.5v12a3.69,3.69,0,1,1-7.38,0V7.63Q71.79,6.93,75.55,6.5Z",
    fill: "#f4c54a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.64,5.94V20.46a3.69,3.69,0,0,1-7.38,0V6c1.4-.06,2.82-.09,4.25-.1C87.56,5.89,88.6,5.9,89.64,5.94Z",
    fill: "#f4c54a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.28,7.34V18.45a3.69,3.69,0,1,1-7.38,0V6.34Q99.67,6.7,103.28,7.34Z",
    fill: "#f4c54a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71,87.23a23.61,23.61,0,1,1-23.6-23.45A23.55,23.55,0,0,1,71,87.23Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.68,84.44a19.14,19.14,0,1,1-19.14-19A19.06,19.06,0,0,1,67.68,84.44Z",
    fill: "url(#6a34c2e1-e381-4e37-9236-fd35b075619c)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.54,104.54A20.1,20.1,0,1,1,68.8,84.44,20.2,20.2,0,0,1,48.54,104.54Zm0-38a17.87,17.87,0,1,0,18,17.87A18,18,0,0,0,48.54,66.57Z",
    fill: "#073e5e"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2,84.53A12.71,12.71,0,1,1,51.5,71.82,12.71,12.71,0,0,1,64.2,84.53Z",
    fill: "#073e5e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.26,88.08a1.93,1.93,0,1,1-1.93-1.93A1.94,1.94,0,0,1,38.26,88.08Z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.72,80.53a4.08,4.08,0,1,0,4.07-4.24A4.16,4.16,0,0,0,37.72,80.53Z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M147.63,87.51a23,23,0,0,1-6.27,15.79,23.13,23.13,0,1,1,6.27-15.79Z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M141.76,85a19.14,19.14,0,1,1-19.13-19A19.06,19.06,0,0,1,141.76,85Z",
    fill: "url(#b42ba3bc-3b34-41ab-8755-ff8180d5d173)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M122.63,105.09A20.1,20.1,0,1,1,142.88,85,20.19,20.19,0,0,1,122.63,105.09Zm0-38a17.87,17.87,0,1,0,18,17.86A18,18,0,0,0,122.63,67.13Z",
    fill: "#073e5e"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M131.86,85.37a12.71,12.71,0,1,1-12.71-12.71A12.71,12.71,0,0,1,131.86,85.37Z",
    fill: "#073e5e"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M137.75,88.08a1.93,1.93,0,1,1-1.93-1.93A1.93,1.93,0,0,1,137.75,88.08Z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M126.16,80.53a4.08,4.08,0,1,0,4.07-4.24A4.16,4.16,0,0,0,126.16,80.53Z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "8c67218b-f264-4271-8f22-a256656816ff",
    "data-name": "MOUTH",
    d: "M100.82,107.27a15.31,15.31,0,0,0-.13-2,15,15,0,0,1-29.93,0,17.19,17.19,0,0,0-.13,2,15.1,15.1,0,1,0,30.19,0Z",
    fill: "#f1b02e"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M51.63,12.69c-2.6,1.6-5.21,3.31-7.8,5.14l-.73.51A104.36,104.36,0,0,0,32.67,26.8c-1.79,1.65-3.5,3.35-5.11,5.09a81.47,81.47,0,0,0-15.21,23,50.49,50.49,0,0,1-1.52-7C8.82,34,12.55,19.26,21.29,7c.22-.31.43-.61.66-.9.76-1,1.55-2,2.38-3l.25-.17a7.6,7.6,0,0,1,4.18-1.39,0,0,0,0,1,0,0c1.35.29,2.68.63,4,1A51.3,51.3,0,0,1,47,9.22l.06,0A50.58,50.58,0,0,1,51.63,12.69Z",
    fill: "#ffce4d"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.67,26.8c-1.79,1.65-3.5,3.35-5.11,5.09a81.47,81.47,0,0,0-15.21,23,50.49,50.49,0,0,1-1.52-7C8.82,34,12.55,19.26,21.29,7,27.34,10.7,31.73,18.05,32.67,26.8Z",
    fill: "#f1b02e"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M119.83,12.48c2.59,1.59,5.19,3.31,7.8,5.13a101.62,101.62,0,0,1,16.26,14.06,81.16,81.16,0,0,1,15.21,23c4.75-16.21,1.13-34.35-9.59-48.83-.76-1-1.55-2-2.39-3l-.24-.18a7.65,7.65,0,0,0-4.18-1.39s0,0,0,0c-1.35.29-2.68.62-4,1A51.39,51.39,0,0,0,124.43,9l-.07,0A47,47,0,0,0,119.83,12.48Z",
    fill: "#ffce4d"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M138.79,27q2.69,2.47,5.1,5.09a81.16,81.16,0,0,1,15.21,23,49.51,49.51,0,0,0,1.52-7c2-13.95-1.72-28.69-10.46-40.94C144.11,10.91,139.72,18.27,138.79,27Z",
    fill: "#f1b02e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewLevel);
export default __webpack_public_path__ + "static/media/IconNewLevel.32e4b08c.svg";
export { ForwardRef as ReactComponent };